module.exports = __webpack_public_path__ + "img/parents-manage-record.c2f52514.svg";